import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { POADocumentType } from '@e-origin/shared';

import { request } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

interface DeleteDocumentProps {
  importerId: string;
  fileName: string;
  type: POADocumentType;
}

export const useDeleteDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ importerId, fileName }: DeleteDocumentProps) => {
      return request({
        path: `importer/delete-document/${importerId}/${fileName}`,
        method: 'POST',
        authenticate: true,
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['importer', variables.importerId] });
      toast.success(`${variables.type} document deleted!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error deleting document!`);
    },
  });
};
